/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { i18n } from '../../../translation/i18n';
import { from, of } from 'rxjs';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { AxiosError } from 'axios';
import { parseError } from '../../../../utils/utils';
import {
    CashBoxErrorHistoryTabAction,
    CashBoxErrorHistoryTabActionType,
    fetchCashBoxErrorsHistoryErrorAction,
    fetchCashBoxErrorsHistorySuccessAction,
} from '../../../actions/CashBoxRegistry/Tabs/CashBoxErrorHistoryTabAction';

export const fetchCashboxErrorsHistoryEpic: Epic<CashBoxErrorHistoryTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY),
        switchMap((action) => {
            const params = action.payload;
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const listName = i18n.t('RegistryScreens.cashBoxErrorsHistory').toLocaleLowerCase();

            return from(cashboxesClient.getErrorsHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashBoxErrorsHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxErrorsHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(CashBoxErrorHistoryTabActionType.EXIT_CASHBOX_ERRORS_HISTORY_TAB)),
            );
        }),
    );
};
